import { createAction } from 'redux-promise-middleware-actions';

export const types = {
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION'
};

export const setNotification = createAction(types.SET_NOTIFICATION, (message) => message);

export const removeNotification = createAction(types.REMOVE_NOTIFICATION);
